import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import PrefectureSelector from "../components/PrefectureSelector";
import "./Home.css";

/* ── 体験談データ（実際のユーザー投稿に置き換え予定） ── */
// eslint-disable-next-line no-unused-vars
const STORIES = [
  {
    id: 1,
    mountain: "北岳",
    elevation: 3193,
    prefecture: "山梨県",
    date: "2025年8月",
    gradient: "sg-1",
    title: "はじめての3000m峰が、人生を変えた",
    story:
      "ひとりで北岳に挑もうとした前日、ヤマッチでメッセージが届いた。「同じルートを歩きませんか」——その一言から、今も続く山仲間との縁が生まれました。山頂で飲んだ、あの熱いコーヒーの味は忘れられません。",
    author: "タカシ",
    prefecture_author: "東京都",
    tags: ["初心者歓迎", "日帰り", "百名山"],
  },
  {
    id: 2,
    mountain: "八ヶ岳（赤岳）",
    elevation: 2899,
    prefecture: "長野県",
    date: "2025年11月",
    gradient: "sg-2",
    title: "初雪の稜線で、助けてもらった話",
    story:
      "11月の八ヶ岳。予想外の初雪に視界が奪われたとき、先行していた3人パーティが足を止めてくれた。「一緒に下りましょう」——その言葉で泣きそうになりました。あの日以来、山での助け合いが好きになった。",
    author: "みどり",
    prefecture_author: "長野県",
    tags: ["経験者向け", "冬季", "テクニカル"],
  },
  {
    id: 3,
    mountain: "槍ヶ岳",
    elevation: 3180,
    prefecture: "長野県",
    date: "2025年7月",
    gradient: "sg-3",
    title: "山頂の握手は、ことばより深かった",
    story:
      "6時間の核心部を越えて山頂に立ったとき、同行した見知らぬ人と無言で握手した。名前も連絡先も知らない。それでもあの手の感触は、一生忘れない。ヤマッチがなければ出会えなかった、大切な瞬間です。",
    author: "ケイスケ",
    prefecture_author: "兵庫県",
    tags: ["中〜上級", "夏季", "本格縦走"],
  },
];

function Home() {
  const { currentUser } = useAuth();

  return (
    <div className="home-wrapper">

      {/* ════════════════════════════════════════
          HERO — 山との出会いを予感させる
          ════════════════════════════════════════ */}
      <section className="home-hero" aria-label="ヤマッチ トップ">
        {/* 背景レイヤー */}
        <div className="hero-bg" aria-hidden="true">
          <div className="hero-sky" />
          <div className="hero-stars" />
          {/* SVG 山シルエット */}
          <svg
            className="hero-mountains-svg"
            viewBox="0 0 1440 480"
            preserveAspectRatio="xMidYMax slice"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            {/* 遠景：最も暗い */}
            <path
              d="M0,480 L0,300 L90,240 L160,270 L240,190 L320,220 L420,140 L500,175 L580,110 L660,155 L750,90 L840,140 L940,160 L1020,120 L1110,155 L1200,130 L1300,168 L1440,145 L1440,480 Z"
              fill="#0a160a"
            />
            {/* 中景 */}
            <path
              d="M0,480 L0,360 L80,320 L180,290 L270,240 L370,270 L450,210 L550,245 L650,195 L740,235 L840,260 L950,220 L1050,255 L1150,230 L1260,265 L1360,245 L1440,280 L1440,480 Z"
              fill="#0e1e0e"
            />
            {/* 前景：最も明るい緑 */}
            <path
              d="M0,480 L0,420 L100,390 L200,370 L310,340 L410,365 L510,330 L610,355 L710,340 L820,370 L930,350 L1040,385 L1150,365 L1260,400 L1440,380 L1440,480 Z"
              fill="#162416"
            />
          </svg>
          <div className="hero-fade-bottom" />
        </div>

        {/* コンテンツ */}
        <div className="hero-content">
          <p className="hero-eyebrow">Hike &amp; Meet</p>
          <h1 className="hero-title">
            山で出会う仲間が、<br />
            <span className="hero-title-accent">旅を変える。</span>
          </h1>
          <p className="hero-desc">
            全国47都道府県の登山メンバー募集・同行者募集。<br className="hide-sp" />
            あなたの山行に、仲間を見つけよう。
          </p>
          <div className="hero-actions">
            <Link to="/recruitments" className="hero-btn hero-btn--primary">
              募集を探す
            </Link>
            {currentUser ? (
              <Link to="/create-recruitment" className="hero-btn hero-btn--ghost">
                山行を募集する
              </Link>
            ) : (
              <Link to="/signup" className="hero-btn hero-btn--ghost">
                無料で始める
              </Link>
            )}
          </div>
        </div>

        {/* スクロールヒント */}
        <div className="hero-scroll" aria-hidden="true">
          <span className="hero-scroll-label">scroll</span>
          <div className="hero-scroll-line" />
        </div>
      </section>

      {/* ════════════════════════════════════════
          体験談 — 心が動く
          ※ サービスリリース後、実際のユーザー体験談が集まったら下記コメントを外す
          ════════════════════════════════════════ */}
      {/*
      <section className="stories-section" aria-labelledby="stories-heading">
        <div className="stories-inner">
          <header className="stories-header">
            <p className="eyebrow">出会いの記録</p>
            <h2 id="stories-heading" className="stories-title">
              あの山で、仲間に出会った。
            </h2>
            <p className="stories-desc">
              ヤマッチから生まれた、本当の出会いと体験談。
            </p>
          </header>

          <div className="stories-grid">
            {STORIES.map((s, i) => (
              <article
                key={s.id}
                className="story-card"
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className={`story-visual ${s.gradient}`} aria-hidden="true">
                  <div className="story-visual-overlay" />
                  <div className="story-visual-info">
                    <span className="story-mountain-name">{s.mountain}</span>
                    <span className="story-elevation">{s.elevation.toLocaleString()}m</span>
                  </div>
                </div>

                <div className="story-body">
                  <div className="story-tags">
                    {s.tags.map((t) => (
                      <span key={t} className="story-tag">{t}</span>
                    ))}
                  </div>
                  <h3 className="story-card-title">{s.title}</h3>
                  <p className="story-text">「{s.story}」</p>
                  <footer className="story-author">
                    <div className="story-avatar" aria-hidden="true">
                      {s.author.charAt(0)}
                    </div>
                    <div>
                      <p className="story-author-name">{s.author}</p>
                      <p className="story-author-meta">
                        {s.prefecture_author} · {s.date} · {s.prefecture}
                      </p>
                    </div>
                  </footer>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      */}

      {/* ════════════════════════════════════════
          応募しよう — CTA
          ════════════════════════════════════════ */}
      <section className="cta-apply" aria-labelledby="apply-heading">
        <div className="cta-inner">
          <div className="cta-content">
            <p className="eyebrow">今すぐ参加できる</p>
            <h2 id="apply-heading" className="cta-title">
              気になる山行が、<br />きっとある。
            </h2>
            <p className="cta-desc">
              北海道から沖縄まで、全国の登山募集一覧。<br />
              初心者歓迎から上級者向けまで、あなたにぴったりの山行を探そう。
            </p>
            <Link to="/recruitments" className="cta-btn cta-btn--apply">
              <span className="cta-btn-icon">🔍</span>
              募集一覧を見る
            </Link>
          </div>

          {/* デコレーティブ モックカード */}
          <div className="cta-deco" aria-hidden="true">
            <div className="deco-card deco-card--back">
              <div className="deco-card-mountain">北岳 3,193m</div>
              <div className="deco-card-meta">8月15日 · 山梨県 · 初級</div>
              <div className="deco-card-count">あと2名</div>
            </div>
            <div className="deco-card deco-card--front">
              <div className="deco-card-badge">新着</div>
              <div className="deco-card-mountain">剱岳 2,999m</div>
              <div className="deco-card-meta">9月14日 · 富山県 · 上級</div>
              <div className="deco-card-count">3名募集中</div>
            </div>
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════════
          都道府県から探す
          ════════════════════════════════════════ */}
      <section className="pref-section" aria-labelledby="pref-heading">
        <div className="pref-inner">
          <header className="pref-header">
            <p className="eyebrow">エリアから探す</p>
            <h2 id="pref-heading" className="pref-title">
              あなたの山は、どこにある？
            </h2>
            <p className="pref-desc">
              都道府県をクリックすると、その地域の登山募集一覧が表示されます。
            </p>
          </header>
          <PrefectureSelector />
        </div>
      </section>

      {/* ════════════════════════════════════════
          募集しよう — 大ボトムCTA
          ════════════════════════════════════════ */}
      <section className="cta-recruit" aria-labelledby="recruit-heading">
        {/* 背景山アート */}
        <div className="recruit-bg" aria-hidden="true">
          <svg
            viewBox="0 0 1440 300"
            preserveAspectRatio="xMidYMax slice"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0,300 L0,200 L160,130 L300,170 L460,80 L600,130 L720,50 L860,110 L1020,70 L1160,120 L1300,90 L1440,130 L1440,300 Z"
              fill="rgba(109,179,63,0.05)"
            />
            <path
              d="M0,300 L0,240 L120,210 L250,180 L380,200 L500,160 L640,185 L780,155 L920,180 L1060,160 L1200,185 L1440,170 L1440,300 Z"
              fill="rgba(109,179,63,0.08)"
            />
          </svg>
        </div>

        <div className="recruit-inner">
          <p className="eyebrow">あなたの山行を</p>
          <h2 id="recruit-heading" className="recruit-title">
            一緒に登る仲間を、<br />
            募集しよう。
          </h2>
          <p className="recruit-desc">
            行きたい山・日程・人数を登録するだけ。<br />
            全国の登山仲間に、あなたの山行が届きます。
          </p>
          <div className="recruit-actions">
            {currentUser ? (
              <Link to="/create-recruitment" className="cta-btn cta-btn--recruit">
                <span className="cta-btn-icon">⛰️</span>
                山行を募集する（無料）
              </Link>
            ) : (
              <>
                <Link to="/signup" className="cta-btn cta-btn--recruit">
                  <span className="cta-btn-icon">⛰️</span>
                  無料で登録して募集する
                </Link>
                <Link to="/login" className="cta-btn cta-btn--ghost-small">
                  ログインする
                </Link>
              </>
            )}
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;
